/* ongod — Styled carousel add-ons (works alongside ongod.js, no changes needed there)
   1. Look fit: finds the person in each transparent PNG and sizes it so every look stands
      full height in the 941:1672 box, centred, feet on the ground shadow. Any image size or padding.
   2. Auto-scroll: steps the carousel every N seconds (data-autoplay on [data-og-wear]).
      Pauses on mouse hover, while swiping, on keyboard focus, off-screen, in background tabs,
      and for Reduce motion. Resumes after 2× the time per look following a swipe/tap/click. */
(function () {
  if (window.ogWearX) return; window.ogWearX = 1;
  var BOX = 941 / 1672, ALPHA = 96, KEY = 'og-fit1:';

  function measure(url, cb) {
    var c = null;
    try { c = JSON.parse(localStorage.getItem(KEY + url)); } catch (e) {}
    if (c && c.length === 5) return cb(c);
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var W = im.naturalWidth, H = im.naturalHeight; if (!W || !H) return cb(null);
      var h = Math.min(H, 480), w = Math.max(1, Math.round(W * h / H)), r = null;
      try {
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var cx = cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(im, 0, 0, w, h);
        var d = cx.getImageData(0, 0, w, h).data, rows = new Uint16Array(h), cols = new Uint16Array(w), clear = false, x, y;
        for (y = 0; y < h; y++) for (x = 0; x < w; x++) { if (d[(y * w + x) * 4 + 3] > ALPHA) { rows[y]++; cols[x]++; } else clear = true; }
        if (clear) {
          /* ignore stray specks: a row/column only counts with a few solid pixels */
          var mr = Math.max(2, Math.round(w * 0.008)), mc = Math.max(2, Math.round(h * 0.004));
          var y0 = 0, y1 = h - 1, x0 = 0, x1 = w - 1;
          while (y0 < h && rows[y0] < mr) y0++; while (y1 > y0 && rows[y1] < mr) y1--;
          while (x0 < w && cols[x0] < mc) x0++; while (x1 > x0 && cols[x1] < mc) x1--;
          if (y1 - y0 > h * 0.2) r = [x0 / w, y0 / h, (x1 + 1) / w, (y1 + 1) / h, W / H].map(function (v) { return Math.round(v * 1e4) / 1e4; });
        }
      } catch (e) { return cb(null); } /* cross-origin without CORS: keep the default fit */
      if (r) try { localStorage.setItem(KEY + url, JSON.stringify(r)); } catch (e) {}
      cb(r);
    };
    im.onerror = function () { cb(null); };
    im.src = url;
  }

  /* b = [left, top, right, bottom] of the person as fractions of the image, + image aspect (w/h) */
  function fit(f, b) {
    var bh = b[3] - b[1], k = 100 / bh, A = b[4] / BOX, s = f.style;
    function p(v) { return v.toFixed(3) + '%'; }
    s.setProperty('--fh', p(k));
    s.setProperty('--fw', p(A * k));
    s.setProperty('--ft', p(-b[1] * k));
    s.setProperty('--fl', p(50 - (b[0] + b[2]) / 2 * A * k));
    s.setProperty('--fo', p(b[3] * 100));                    /* feet line, for the studio reflection */
    s.setProperty('--fm', p((1 - b[3]) * 100));
    s.setProperty('--ff', p((1 - b[3]) * 100 + 18 * bh));
    f.classList.remove('is-raw'); f.classList.add('is-fit');
  }

  function fitLooks(root) {
    var figs = [].slice.call(root.querySelectorAll('.og-wear__fig'));
    root.classList.add('og-fitting');
    figs.forEach(function (f) {
      var main = f.querySelector('img:not(.r)'), url = f.getAttribute('data-fit') || (main && main.currentSrc) || (main && main.src);
      if (!url) return f.classList.add('is-raw');
      measure(url, function (b) { if (b) fit(f, b); else f.classList.add('is-raw'); });
    });
    setTimeout(function () { figs.forEach(function (f) { if (!f.classList.contains('is-fit')) f.classList.add('is-raw'); }); }, 2500);
  }

  function autoplay(root) {
    var sec = parseFloat(root.getAttribute('data-autoplay')), tile = root.querySelector('.og-wear__tile');
    if (!(sec > 0) || !tile || root.querySelectorAll('.og-wear__fig').length < 2) return;
    /* left to right = looks travel rightwards = the Previous arrow */
    var btn = root.querySelector(root.getAttribute('data-autoplay-dir') === 'rtl' ? '[data-og-wear-next]' : '[data-og-wear-prev]');
    if (!btn) return;
    var rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var t = null, auto = false, hover = false, held = false, kb = false, seen = !('IntersectionObserver' in window);
    var SC = ['desert', 'cracked', 'hills'], shown = 0, picked = false; /* backdrop: next one every 6 auto-looks, until a shopper picks one */ function bg() { if (picked || ++shown % 6) return; var on = root.querySelector('.og-wear__sc.is-on'), i = on ? SC.indexOf(on.getAttribute('data-scene')) : -1; if (i < 0) return; var nb = root.querySelector('.og-wear__sc[data-scene="' + SC[(i + 1) % 3] + '"]'); if (nb) nb.click(); } root.addEventListener('click', function (e) { if (!auto && e.target.closest && e.target.closest('.og-wear__sc')) picked = true; }, true); function arm(mul) {
      clearTimeout(t); t = null;
      if (!root.isConnected || hover || held || kb || !seen || document.hidden || (rm && rm.matches)) return;
      t = setTimeout(function () {
        if (!root.isConnected) return;
        auto = true; btn.click(); bg(); auto = false; arm(1);
      }, (sec * 1000 + 500) * (mul || 1));
    }
    tile.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; arm(); } });
    tile.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; arm(1); } });
    tile.addEventListener('pointerdown', function () { held = true; arm(); });
    function release() { if (!held) return; held = false; arm(2); }
    tile.addEventListener('pointerup', release); tile.addEventListener('pointercancel', release); tile.addEventListener('lostpointercapture', release);
    tile.addEventListener('focusin', function (e) { var v = false; try { v = e.target.matches(':focus-visible'); } catch (x) {} if (v) { kb = true; arm(); } });
    tile.addEventListener('focusout', function (e) { if (!tile.contains(e.relatedTarget)) { kb = false; arm(1); } });
    tile.addEventListener('keydown', function () { arm(); });
    root.addEventListener('click', function () { if (!auto) arm(2); }, true); /* arrows, looks, backdrop picker */
    document.addEventListener('visibilitychange', function () { arm(1); });
    if (rm && rm.addEventListener) rm.addEventListener('change', function () { arm(1); });
    if (!seen) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; arm(1); }, { threshold: 0.35 }).observe(tile);
    arm(1);
  }

  function init(root) {
    if (root.dataset.ogX) return; root.dataset.ogX = '1';
    fitLooks(root); autoplay(root);
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-og-wear]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
